module.exports = __webpack_public_path__ + "static/media/CPG.da278572.png";